module.exports = __webpack_public_path__ + "img/img-peitu.0f1eddf5.png";